import React from 'react';

/**
 * Полноэкранный индикатор загрузки приложения.
 *
 * Крутится быстро (см. токен `spin` в tailwind.config.js): скорость вращения
 * напрямую влияет на то, насколько быстрым кажется приложение, при том же
 * реальном времени загрузки. Под reduced-motion вращение замедляется, но не
 * останавливается — это обратная связь, а не декорация.
 */
const Spinner: React.FC = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-ink-50 dark:bg-ink-950">
            <div className="flex flex-col items-center gap-4">
                <div
                    className="animate-spin rounded-full h-12 w-12 border-2 border-ink-200 dark:border-white/10 border-t-brand-500"
                    role="status"
                    aria-label="Загрузка"
                />
                <p className="text-ink-500 dark:text-ink-400 text-sm font-medium">Загрузка…</p>
            </div>
        </div>
    );
};

export default Spinner;
